import React from 'react';
import './Login.css';

const isDev = window.location.hostname === 'localhost';

const Login = ({ initialError = '', onLogin }) => {
  const devLogin = async () => {
    const res = await fetch('/api/auth/dev-login', { method: 'POST' });
    const data = await res.json();
    if (data.token) {
      localStorage.setItem('intranet_token', data.token);
      onLogin({ ...data });
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">

        <div className="login-brand">
          <img src="/logos/esbrook_pc_logo_web_no_bg_black.png" alt="Esbrook P.C." className="login-brand-logo" />
          <p>Firm Intranet</p>
        </div>

        {initialError && <p className="login-error">{initialError}</p>}

        <a href="/api/auth/microsoft/login" className="login-ms-btn">
          <svg width="18" height="18" viewBox="0 0 23 23"><path fill="#f25022" d="M1 1h10v10H1z"/><path fill="#7fba00" d="M12 1h10v10H12z"/><path fill="#00a4ef" d="M1 12h10v10H1z"/><path fill="#ffb900" d="M12 12h10v10H12z"/></svg>
          Sign in with Microsoft
        </a>

        {isDev && (
          <button onClick={devLogin} className="login-dev-btn">
            Dev Admin Login (local only)
          </button>
        )}
      </div>
    </div>
  );
};

export default Login;
